import { IPoint } from "@multiweb/picasso";
import { ActionType } from "../enums";
import { IAction } from "../types";
import { CONST_SET_OBJECT_ATTRIBUTE_ATTR_NAME_AT, CONST_SET_OBJECT_ATTRIBUTE_VALUE_EL } from "../workflowParser/constants";

/**
 * Vrací seznam kódů stavů WF ze všech akcí typu 'Změna vazebního atributu'.
 * @param actions Seznam všech akcí na aktivitě/propojení.
 */
export const getWfStateCodes = (actions: readonly IAction[]) => {
    const wfStateCodes: string[] = [];

    actions.forEach(action => {
        if (action.actionType === ActionType.SetObjectAttribute && action.properties[CONST_SET_OBJECT_ATTRIBUTE_ATTR_NAME_AT] === "Stav_WF")
            wfStateCodes.push(action.properties[CONST_SET_OBJECT_ATTRIBUTE_VALUE_EL]);
    });

    return wfStateCodes;
};

/**
 * Funkce starající se o zkrácení textu nad propojeními. (SVG text tuto vlastnost neumí, proto si pomáháme takhle...)
 * @param text Text, který se má zkrátit, pokud přesahuje určitou délku.
 */
export const textEllipsis = (text: string | undefined) => {
    const MAX_NUMBER_OF_CHARS = 16;

    if (text !== undefined && text.length > MAX_NUMBER_OF_CHARS)
        return `${text.substring(0, MAX_NUMBER_OF_CHARS)}...`;

    return text;
};

/**
 * Vypočítává úhel sklonu textu na propojení, který je mezi počátečním a koncovým bodem.
 * Zároveň tento úhel invertuje tak, aby text nikdy nebyl vzhůru nohama.
 * @param startPoint Počáteční bod propojení.
 * @param endPoint Koncový bod propojení.
 */
export const calcAngleDegrees = (startPoint: IPoint, endPoint: IPoint) => {
    const cathetusA = endPoint.x - startPoint.x; // délka odvěsny 'a'
    const cathetusB = endPoint.y - startPoint.y; // délka odvěsny 'b'
    const angleInDegrees = Math.atan2(cathetusB, cathetusA) * 180 / Math.PI; // převod tangens na stupně, jedná se o sklon vůči ose X

    if (angleInDegrees > 90) // zajišťuje překlopení textu, pokud se konec propojení dostane ze IV. do III. kvadrantu
        return angleInDegrees - 180;

    if (angleInDegrees < -90) // zajišťuje překlopení textu, pokud se konec propojení dostane ze II. do I. kvadrantu
        return 180 + angleInDegrees;

    return angleInDegrees;
};
